<template>
  <div
    id="meiDuSha"
    :class="{
      box: true,
      'landscape-box': isLandscape,
      'portrait-box': !isLandscape,
      en: isEn,
    }"
  >
    <div
      id="meiDuShaModule1"
      :style="{ 'background-image': 'url(' + imageUrl1 + ')' }"
      v-lazy="imageUrl1"
    >
      <div id="meiDuShaModule1Text" class="gaiAModule1">
        <div
          id="meiDuShaModule1TextText1"
          class="module1 pre-wrap"
          v-text="$t('productCentermeidushaView').title.h1"
        ></div>
        <div id="meiDuShaModule1TextText2" class="module1">
          {{ $t("productCentermeidushaView").title.h2 }}
        </div>
      </div>
    </div>
    <div id="coteent">
      <div
        id="meiDuShaModule2"
        :style="{ 'background-image': 'url(' + imageUrl2 + ')' }"
        v-lazy="imageUrl2"
      >
        <!-- <div id="meiDuShaModule2Left" class="wow animate__animated animate__fadeInUp">
          <div id="meiDuShaModule2LeftTitle">{{ $t('productCentermeidushaView').title.h3 }}</div>
          <div id="meiDuShaModule2LeftText1">{{ $t('productCentermeidushaView').title.h4 }}</div>
          <div id="meiDuShaModule2LeftText2"> {{ $t('productCentermeidushaView').title.h5 }}</div>
        </div>
        <div id="meiDuShaModule2Right" class="wow animate__animated animate__fadeInUp">
          <img src="@/static/img/meiDuShaComputer.png" alt="">
        </div> -->
        <div class="tit wow animate__animated animate__fadeInUp">
          <div class="h1">
            {{ $t("productCentermeidushaView.title.h3") }}
          </div>
          <div class="h2 text-left">
            {{ $t("productCentermeidushaView.title.h4") }}
          </div>
        </div>
        <div class="img wow animate__animated animate__fadeInUp">
          <img :src="$t('productCentermeidushaView.introImg')" alt="" />
        </div>
      </div>
      <div
        id="meiDuShaModule3"
        :style="{ 'background-image': 'url(' + imageUrl3 + ')' }"
        v-lazy="imageUrl3"
      >
        <div
          id="meiDuShaModule3Top"
          class="wow animate__animated animate__fadeInUp"
        >
          {{ $t("productCentermeidushaView").meiDuShaModule3.h1 }}
        </div>
        <div id="meiDuShaModule3Bottom">
          <div id="meiDuShaModuleNineContentCenter">
            <div
              id="meiDuShaModuleNineContentOne"
              class="wow animate__animated animate__fadeInUp"
              style="animation-duration: 1s !important"
            >
              <div id="meiDuShaModuleNineContentOneTop">
                <img
                  src="@/static/img/meiDuShaUltraHghComputingPowerIcon.png"
                  alt=""
                />
              </div>
              <div id="meiDuShaModuleNineContentOneCenter">
                {{
                  $t("productCentermeidushaView").meiDuShaModule3
                    .meiDuShaModule3Arr[0].h1
                }}
              </div>
              <div id="meiDuShaModuleNineContentOneBottom">
                {{
                  $t("productCentermeidushaView").meiDuShaModule3
                    .meiDuShaModule3Arr[0].h2
                }}
              </div>
            </div>
            <div
              id="meiDuShaModuleNineContentTwo"
              class="wow animate__animated animate__fadeInUp"
              style="animation-duration: 1.3s !important"
            >
              <div id="meiDuShaModuleNineContentTwoTop">
                <img src="@/static/img/meiDuShaSensorIcon.png" alt="" />
              </div>
              <div id="meiDuShaModuleNineContentTwoCenter">
                {{
                  $t("productCentermeidushaView").meiDuShaModule3
                    .meiDuShaModule3Arr[1].h1
                }}
              </div>
              <div id="meiDuShaModuleNineContentTwoBottom">
                {{
                  $t("productCentermeidushaView").meiDuShaModule3
                    .meiDuShaModule3Arr[1].h2
                }}
              </div>
            </div>
            <div
              id="meiDuShaModuleNineContentThree"
              class="wow animate__animated animate__fadeInUp"
              style="animation-duration: 1.6s !important"
            >
              <div id="meiDuShaModuleNineContentThreeTop">
                <img src="@/static/img/meiDuShaDynamicModuleIcon.png" alt="" />
              </div>
              <div id="meiDuShaModuleNineContentThreeCenter">
                {{
                  $t("productCentermeidushaView").meiDuShaModule3
                    .meiDuShaModule3Arr[2].h1
                }}
              </div>
              <div id="meiDuShaModuleNineContentThreeBottom">
                {{
                  $t("productCentermeidushaView").meiDuShaModule3
                    .meiDuShaModule3Arr[2].h2
                }}
              </div>
            </div>
            <div
              id="meiDuShaModuleNineContentFour"
              class="wow animate__animated animate__fadeInUp"
              style="animation-duration: 1.9s !important"
            >
              <div id="meiDuShaModuleNineContentFourTop">
                <img
                  src="@/static/img/meiDuShaHighFidelityLowLatencyIcon.png"
                  alt=""
                />
              </div>
              <div id="meiDuShaModuleNineContentFourCenter">
                {{
                  $t("productCentermeidushaView").meiDuShaModule3
                    .meiDuShaModule3Arr[3].h1
                }}
              </div>
              <div id="meiDuShaModuleNineContentFourBottom">
                {{
                  $t("productCentermeidushaView").meiDuShaModule3
                    .meiDuShaModule3Arr[3].h2
                }}
              </div>
            </div>
            <div
              id="meiDuShaModuleNineContentFive"
              class="wow animate__animated animate__fadeInUp"
              style="animation-duration: 2.2s !important"
            >
              <div id="meiDuShaModuleNineContentFiveTop">
                <img
                  src="@/static/img/meiDuShaCommunicationInterfaceIcon.png"
                  alt=""
                />
              </div>
              <div id="meiDuShaModuleNineContentFiveCenter">
                {{
                  $t("productCentermeidushaView").meiDuShaModule3
                    .meiDuShaModule3Arr[4].h1
                }}
              </div>
              <div id="meiDuShaModuleNineContentFiveBottom">
                {{
                  $t("productCentermeidushaView").meiDuShaModule3
                    .meiDuShaModule3Arr[4].h2
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div id="meiDuShaFooter">
        <FooterComponents></FooterComponents>
      </div> -->
    </div>
    <div id="coteent1">
      <!-- 传感器仿真注入方案 -->
      <div id="multiSensorHiLModule2">
        <div id="multiSensorHiLModule2Content">
          <div
            id="multiSensorHiLModule2Title"
            class="wow animate__animated animate__fadeInUp"
          >
            {{ $t("productCenterHiLView").multiSensorHiLModule2.h1 }}
          </div>
          <!-- 传感器仿真注入方案  -->
          <div
            id="multiSensorHiLModule2Process"
            class="wow animate__animated animate__fadeInUp"
          >
            <!-- 左 -->
            <div class="medushaTitle">
              <div class="name">
                {{ $t("productCentermeidushaView.title.h3") }}
              </div>
              <div class="nameBox">
                <div
                  id="multiSensorHiLModule2ProcessLeftBoxLeft"
                  :style="{ 'background-image': 'url(' + imageUrl55 + ')' }"
                  v-lazy="imageUrl55"
                >
                  {{
                    $t("productCenterHiLView").multiSensorHiLModule2
                      .multiSensorHiLModule2ProcessLeft
                      .multiSensorHiLModule2Arr[0]
                  }}
                </div>
                <div
                  id="multiSensorHiLModule2ProcessLeftBoxLeft"
                  :style="{ 'background-image': 'url(' + imageUrl55 + ')' }"
                  v-lazy="imageUrl55"
                >
                  {{
                    $t("productCenterHiLView").multiSensorHiLModule2
                      .multiSensorHiLModule2ProcessLeft
                      .multiSensorHiLModule2Arr[2]
                  }}
                </div>
                <div
                  id="multiSensorHiLModule2ProcessLeftBoxLeft"
                  :style="{ 'background-image': 'url(' + imageUrl55 + ')' }"
                  v-lazy="imageUrl55"
                >
                  {{
                    $t("productCenterHiLView").multiSensorHiLModule2
                      .multiSensorHiLModule2ProcessLeft
                      .multiSensorHiLModule2Arr[4]
                  }}
                </div>
              </div>
            </div>
            <!-- 中 -->
            <div id="multiSensorHiLModule2ProcessLeft">
              <!-- 基于传感器总成 -->
              <div id="multiSensorHiLModule2ProcessLeftBox1">
                <div
                  id="multiSensorHiLModule2ProcessLeftBoxRight"
                  :style="{ 'background-image': 'url(' + imageUrl66 + ')' }"
                  v-lazy="imageUrl66"
                >
                  {{
                    $t("productCenterHiLView").multiSensorHiLModule2
                      .multiSensorHiLModule2ProcessLeft
                      .multiSensorHiLModule2Arr[1]
                  }}
                </div>
              </div>
              <!-- 传感器原始数据注入 -->
              <div id="multiSensorHiLModule2ProcessLeftBox2">
                <div
                  id="multiSensorHiLModule2ProcessLeftBoxRight"
                  :style="{ 'background-image': 'url(' + imageUrl66 + ')' }"
                  v-lazy="imageUrl66"
                >
                  {{
                    $t("productCenterHiLView").multiSensorHiLModule2
                      .multiSensorHiLModule2ProcessLeft
                      .multiSensorHiLModule2Arr[3]
                  }}
                </div>
              </div>
              <!-- 目标列表注入及残余总线仿真 -->
              <div id="multiSensorHiLModule2ProcessLeftBox3">
                <div
                  id="multiSensorHiLModule2ProcessLeftBoxRight"
                  :style="{ 'background-image': 'url(' + imageUrl66 + ')' }"
                  v-lazy="imageUrl66"
                >
                  {{
                    $t("productCenterHiLView").multiSensorHiLModule2
                      .multiSensorHiLModule2ProcessLeft
                      .multiSensorHiLModule2Arr[5]
                  }}
                </div>
              </div>
            </div>
            <!-- 右 -->
            <div id="multiSensorHiLModule2ProcessRight">
              <div
                id="multiSensorHiLModule2ProcessRightRow"
                :style="{ 'background-image': 'url(' + imageUrl99 + ')' }"
                v-lazy="imageUrl99"
              >
                <div
                  id="multiSensorHiLModule2ProcessRightRowSense1"
                  :style="{ 'background-image': 'url(' + imageUrl88 + ')' }"
                  v-lazy="imageUrl88"
                >
                  <div id="multiSensorHiLModule2ProcessRightRowSenseBox">
                    <div id="multiSensorHiLModule2ProcessRightRowSenseBoxImg">
                      <img src="@/static/img/HiLSense.png" alt="" />
                    </div>
                    {{
                      $t("productCenterHiLView").multiSensorHiLModule2
                        .multiSensorHiLModule2ProcessRight
                        .multiSensorHiLModule2Arr[0]
                    }}
                  </div>
                  <div id="multiSensorHiLModule2ProcessRightRowSenseContent">
                    {{
                      $t("productCenterHiLView").multiSensorHiLModule2
                        .multiSensorHiLModule2ProcessRight
                        .multiSensorHiLModule2Arr[1]
                    }}
                  </div>
                </div>
                <div
                  id="multiSensorHiLModule2ProcessRightRowSense2"
                  :style="{ 'background-image': 'url(' + imageUrl88 + ')' }"
                  v-lazy="imageUrl88"
                >
                  <div id="multiSensorHiLModule2ProcessRightRowSenseBox">
                    <div id="multiSensorHiLModule2ProcessRightRowSenseBoxImg">
                      <img src="@/static/img/HiLperception.png" alt="" />
                    </div>
                    {{
                      $t("productCenterHiLView").multiSensorHiLModule2
                        .multiSensorHiLModule2ProcessRight
                        .multiSensorHiLModule2Arr[2]
                    }}
                  </div>
                  <div id="multiSensorHiLModule2ProcessRightRowSenseContent">
                    {{
                      $t("productCenterHiLView").multiSensorHiLModule2
                        .multiSensorHiLModule2ProcessRight
                        .multiSensorHiLModule2Arr[3]
                    }}
                  </div>
                </div>
                <div
                  id="multiSensorHiLModule2ProcessRightRowSense3"
                  :style="{ 'background-image': 'url(' + imageUrl88 + ')' }"
                  v-lazy="imageUrl88"
                >
                  <div id="multiSensorHiLModule2ProcessRightRowSenseBox">
                    <div id="multiSensorHiLModule2ProcessRightRowSenseBoxImg">
                      <img src="@/static/img/HiLmerge.png" alt="" />
                    </div>
                    {{
                      $t("productCenterHiLView").multiSensorHiLModule2
                        .multiSensorHiLModule2ProcessRight
                        .multiSensorHiLModule2Arr[4]
                    }}
                  </div>
                  <div id="multiSensorHiLModule2ProcessRightRowSenseContent">
                    {{
                      $t("productCenterHiLView").multiSensorHiLModule2
                        .multiSensorHiLModule2ProcessRight
                        .multiSensorHiLModule2Arr[5]
                    }}
                  </div>
                </div>
                <div
                  id="multiSensorHiLModule2ProcessRightRowSense4"
                  :style="{ 'background-image': 'url(' + imageUrl88 + ')' }"
                  v-lazy="imageUrl88"
                >
                  <div id="multiSensorHiLModule2ProcessRightRowSenseBox">
                    <div id="multiSensorHiLModule2ProcessRightRowSenseBoxImg">
                      <img src="@/static/img/HiLApplication.png" alt="" />
                    </div>
                    {{
                      $t("productCenterHiLView").multiSensorHiLModule2
                        .multiSensorHiLModule2ProcessRight
                        .multiSensorHiLModule2Arr[6]
                    }}
                  </div>
                  <div id="multiSensorHiLModule2ProcessRightRowSenseContent">
                    {{
                      $t("productCenterHiLView").multiSensorHiLModule2
                        .multiSensorHiLModule2ProcessRight
                        .multiSensorHiLModule2Arr[7]
                    }}
                  </div>
                </div>
              </div>
              <div
                id="multiSensorHiLModule2ProcessRightCol"
                :style="{ 'background-image': 'url(' + imageUrl77 + ')' }"
                v-lazy="imageUrl77"
              >
                <!-- <span v-if="showTestObject" class="vertical-text"
                  >A<br />D<br />A<br />S<br />/<br />A<br />D<br />被<br />测<br />对<br />象</span
                >
                <span v-else class="vertical-text"
                  >A<br />D<br />A<br />S<br />/<br />A<br />D<br />O<br />b<br />j<br />e<br />c<br />t</span
                > -->
                <!-- <span
                  v-for="(item, index) in $t(
                    'productCenterHiLView.multiSensorHiLModule2.testObject'
                  )"
                  :key="item + index"
                >
                  {{ item }}
                </span> -->
                <span
                  v-text="
                    $t('productCenterHiLView.multiSensorHiLModule2.testObject')
                  "
                  class="test-object pre-wrap"
                >
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 实时多路径，高效多并发 -->
      <div
        id="multiSensorHiLModule3"
        :style="{ 'background-image': 'url(' + imageUrl1010 + ')' }"
        v-lazy="imageUrl1010"
      >
        <div id="multiSensorHiLModule3Box">
          <div
            id="multiSensorHiLModule3Title"
            class="wow animate__animated animate__fadeInUp"
          >
            {{ $t("productCenterHiLView").multiSensorHiLModule3 }}
          </div>
          <div
            id="multiSensorHiLModule3Video"
            class="wow animate__animated animate__fadeInUp"
          >
            <img src="@/static/img/HiLProductBanner.png" alt="" />
          </div>
        </div>
      </div>
      <div id="multiSensorHiLFooter">
        <FooterComponents></FooterComponents>
      </div>
    </div>
  </div>
</template>

<script>
import FooterComponents from "@/components/FooterComponents.vue";
import WOW from "wowjs";

export default {
  computed: {
    isLandscape() {
      return Math.abs(window.orientation) === 90;
    },
    lang() {
      return this.$i18n.locale;
    },
    isEn() {
      return this.lang === "en-US";
    },
  },
  components: {
    FooterComponents,
  },
  data() {
    return {
      imageUrl1: require("@/static/img/MeiDuShaBanner.png"),
      imageUrl2: require("@/static/img/meiDuShaModuleTwoBanner.png"),
      imageUrl3: require("@/static/img/meiDuShaModuleThreeBanner.png"),
      showTestObject: true,

      imageUrl55: require("@/static/img/HiLBox.png"),
      imageUrl66: require("@/static/img/HiLArrow.png"),
      imageUrl77: require("@/static/img/HilColorCol.png"),
      imageUrl88: require("@/static/img/HilColorBox.png"),
      imageUrl99: require("@/static/img/HiLRowBg.png"),
      imageUrl1010: require("@/static/img/HiLProductBg.png"),
    };
  },
  created() {
    const reloadOnOrientationChange = () => {
      const isLandscape = Math.abs(window.orientation) === 90;
      if (isLandscape) {
        location.reload();
      } else {
        location.reload();
      }
    };
    window.addEventListener("orientationchange", reloadOnOrientationChange);
  },
  mounted() {
    const wow = new WOW.WOW({
      live: false,
    });
    wow.init();
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.landscape-box {
  /* 横屏 */
  /* display: flex;
    flex-direction: column; */
}

.portrait-box {
  /* 竖屏 */
  display: flex;
  flex-direction: column;
}

#meiDuSha {
  width: 100%;
  height: 100%;

  @mixin whar($width, $height, $atio) {
    width: $width;
    height: $height;
    aspect-ratio: $atio;
    box-sizing: border-box;
  }

  @mixin bgar($atio) {
    text-align: center;
    margin-right: 1.5rem;
    aspect-ratio: $atio;
    background-size: contain;
    background-repeat: no-repeat;
  }

  @mixin display {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @mixin commitaspct {
    opacity: 1;
    width: 50%;
    aspect-ratio: 720/600;
    background-size: contain;
    background-repeat: no-repeat;
  }

  @mixin fontStyle(
    $fontweight,
    $height,
    $fontSize,
    $lineHeight,
    $letterSpaceing,
    $color
  ) {
    width: fit-content;
    font-weight: $fontweight;
    height: $height;
    font-size: $fontSize;
    font-style: normal;
    line-height: $lineHeight;
    letter-spacing: $letterSpaceing;
    color: $color;
  }

  @mixin shotFontStyle($color, $fontSize, $fontweight, $lineHeight) {
    color: $color;
    font-size: $fontSize;
    font-style: normal;
    font-weight: $fontweight;
    line-height: $lineHeight;
  }

  #meiDuShaModule1 {
    background-size: cover;
    @include whar(100%, auto, 1440/480);
    padding: 12.9375rem 0rem 11rem 12.8125rem;

    #meiDuShaModule1Text {
      height: 7.75rem;
      width: fit-content;
      line-height: 3.875rem;

      #meiDuShaModule1TextText1 {
        @include fontStyle(
          600,
          // 3.875rem,
          "",
          2.5rem,
          3.875rem,
          0.06944rem,
          rgba(255, 255, 255, 0.85)
        );
      }

      #meiDuShaModule1TextText2 {
        margin-top: 0.75rem;
        @include fontStyle(
          400,
          2rem,
          1.0625rem,
          2rem,
          0.06944rem,
          rgba(255, 255, 255, 0.65)
        );
      }
    }
  }

  #coteent {
    flex: 1;
    display: flex;
    flex-direction: column;

    #meiDuShaModule2 {
      height: 45.5rem;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: 100% 100%;
      text-align: center;

      .tit {
        width: 40.5rem;
        margin: 0 auto;
        margin-top: 6.25rem;

        .h1 {
          color: rgba(255, 255, 255, 0.85);
          font-size: 2.25rem;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
          margin-bottom: 1rem;
        }

        .h2 {
          color: rgba(255, 255, 255, 0.65);
          font-size: 0.875rem;
          font-style: normal;
          font-weight: 400;
          line-height: 1.625rem;
        }
      }

      .img {
        width: 50rem;
        height: 31.875rem;
        margin: 0 auto;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }

    #meiDuShaModule3 {
      flex: 0.5;
      /* display: flex; */
      flex-direction: column;
      background-size: cover;
      padding-top: 4.875rem;
      box-sizing: border-box;
      @include whar(100%, auto, 2880/1096);
      @include display;

      #meiDuShaModule3Top {
        margin: 0 auto;
        width: 48.75rem;
        height: 3.125rem;
        text-align: center;
        margin-bottom: 1rem;
        @include shotFontStyle(rgba(255, 255, 255, 0.85), 2.25rem, 600, normal);
      }

      #meiDuShaModule3Bottom {
        display: flex;
        height: 25.25rem;
        justify-content: center;

        #meiDuShaModuleNineContentCenter {
          width: 84rem;
          display: flex;

          #meiDuShaModuleNineContentOne {
            width: 16.8rem;
            height: 24rem;
            box-sizing: border-box;
            padding: 4.06rem 2rem;

            #meiDuShaModuleNineContentOneTop {
              width: 4rem;
              height: 4rem;
              margin: 0 auto 1.06rem;

              img {
                width: 4rem;
                height: 4rem;
              }
            }

            #meiDuShaModuleNineContentOneCenter {
              text-align: center;
              @include shotFontStyle(
                rgba(255, 255, 255, 0.85),
                1.5rem,
                500,
                2.25rem
              );
            }

            #meiDuShaModuleNineContentOneBottom {
              margin-top: 1.25rem;
              text-align: center;
              @include shotFontStyle(
                rgba(255, 255, 255, 0.65),
                0.875rem,
                400,
                1.625rem
              );
            }
          }

          #meiDuShaModuleNineContentTwo {
            width: 16.8rem;
            height: 24rem;
            box-sizing: border-box;
            padding: 4.06rem 2rem;

            #meiDuShaModuleNineContentTwoTop {
              width: 4rem;
              height: 4rem;
              margin: 0 auto 1.06rem;

              img {
                width: 4rem;
                height: 4rem;
              }
            }

            #meiDuShaModuleNineContentTwoCenter {
              text-align: center;
              @include shotFontStyle(
                rgba(255, 255, 255, 0.85),
                1.5rem,
                500,
                2.25rem
              );
            }

            #meiDuShaModuleNineContentTwoBottom {
              margin-top: 1.25rem;
              text-align: center;
              @include shotFontStyle(
                rgba(255, 255, 255, 0.65),
                0.875rem,
                400,
                1.625rem
              );
              height: 10rem;
              overflow: hidden;
              overflow-y: auto;

              /* 设置滚动条的宽度和颜色 */
              &::-webkit-scrollbar {
                width: 0;
                background-color: #f1f1f1;
              }
            }
          }

          #meiDuShaModuleNineContentThree {
            width: 16.8rem;
            height: 24rem;
            box-sizing: border-box;
            padding: 4.06rem 2rem;

            #meiDuShaModuleNineContentThreeTop {
              width: 4rem;
              height: 4rem;
              margin: 0 auto 1.06rem;

              img {
                width: 4rem;
                height: 4rem;
              }
            }

            #meiDuShaModuleNineContentThreeCenter {
              text-align: center;
              @include shotFontStyle(
                rgba(255, 255, 255, 0.85),
                1.5rem,
                500,
                2.25rem
              );
            }

            #meiDuShaModuleNineContentThreeBottom {
              margin-top: 1.25rem;
              text-align: center;
              @include shotFontStyle(
                rgba(255, 255, 255, 0.65),
                0.875rem,
                400,
                1.625rem
              );
            }
          }

          #meiDuShaModuleNineContentFour {
            width: 16.8rem;
            height: 24rem;
            box-sizing: border-box;
            padding: 4.06rem 2rem;

            #meiDuShaModuleNineContentFourTop {
              width: 4rem;
              height: 4rem;
              margin: 0 auto 1.06rem;

              img {
                width: 4rem;
                height: 4rem;
              }
            }

            #meiDuShaModuleNineContentFourCenter {
              text-align: center;
              @include shotFontStyle(
                rgba(255, 255, 255, 0.85),
                1.5rem,
                500,
                2.25rem
              );
            }

            #meiDuShaModuleNineContentFourBottom {
              margin-top: 1.25rem;
              text-align: center;
              @include shotFontStyle(
                rgba(255, 255, 255, 0.65),
                0.875rem,
                400,
                1.625rem
              );
            }
          }

          #meiDuShaModuleNineContentFive {
            width: 16.8rem;
            height: 24rem;
            box-sizing: border-box;
            padding: 4.06rem 2rem;

            #meiDuShaModuleNineContentFiveTop {
              width: 4rem;
              height: 4rem;
              margin: 0 auto 1.06rem;

              img {
                width: 4rem;
                height: 4rem;
              }
            }

            #meiDuShaModuleNineContentFiveCenter {
              text-align: center;
              @include shotFontStyle(
                rgba(255, 255, 255, 0.85),
                1.5rem,
                500,
                2.25rem
              );
            }

            #meiDuShaModuleNineContentFiveBottom {
              margin-top: 1.25rem;
              text-align: center;
              @include shotFontStyle(
                rgba(255, 255, 255, 0.65),
                0.875rem,
                400,
                1.625rem
              );
            }
          }
        }
      }
    }

    #meiDuShaFooter {
      width: 100%;
      height: 18rem;
    }
  }

  #coteent1 {
    flex: 1;
    display: flex;
    flex-direction: column;

    #multiSensorHiLModule2 {
      width: 100%;
      flex: 0.5;
      padding: 4.875rem 0 0 0;
      @include display;

      #multiSensorHiLModule2Content {
        width: 100%;

        #multiSensorHiLModule2Title {
          margin: auto;
          @include fontStyle(
            600,
            3.125rem,
            2.25rem,
            3.125rem,
            0.06944rem,
            rgba(255, 255, 255, 0.85)
          );
        }

        #multiSensorHiLModule2Process {
          margin: auto;
          display: flex;
          padding: 0 12.0625rem;
          height: 18.75rem;
          margin-top: 3.625rem;

          .medushaTitle {
            display: flex;
            align-items: center;
            border-radius: 0.25rem;
            border: 0.0625rem solid #282d45;
            background: #0e1330;
            margin-right: 1.5rem;

            .name {
              width: 4rem;
              height: 100%;
              line-height: 4rem;
              text-align: center;
              margin: auto 0;
              color: rgba(255, 255, 255, 0.85);
              text-align: center;
              font-size: 1rem;
              font-style: normal;
              font-weight: 500;
              writing-mode: vertical-rl;
              border-radius: 0.25rem 0px 0px 0.25rem;
              border-right: 0.0625rem solid var(--Neutral-gray-500, #282d45);
              background: url("@/static/img/meidushaName_bg.png") no-repeat 100%
                100%;
              background-size: cover;
              margin-right: 1.5rem;
            }

            .nameBox {
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: space-evenly;
            }

            #multiSensorHiLModule2ProcessLeftBoxLeft {
              display: flex;
              align-items: center;
              justify-content: center;
              @include bgar(260/56);
              color: rgba(255, 255, 255, 0.85);
              width: fit-content;
              font-weight: 400;
              height: 3.5rem;
              font-size: 1rem;
              font-style: normal;
              color: rgba(255, 255, 255, 0.85);
            }
          }

          #multiSensorHiLModule2ProcessLeft {
            display: flex;
            height: 18.75rem;
            box-sizing: border-box;
            flex-direction: column;
            justify-content: space-evenly;

            #multiSensorHiLModule2ProcessLeftBoxRight {
              display: flex;
              align-items: center;
              justify-content: center;
              @include bgar(393/116);
              color: rgba(255, 255, 255, 0.85);
              width: fit-content;
              font-weight: 400;
              height: 3.5rem;
              font-size: 1rem;
              font-style: normal;
              color: rgba(255, 255, 255, 0.85);
            }
          }

          #multiSensorHiLModule2ProcessRight {
            flex: 1;
            display: flex;
            flex-direction: row;
            border-radius: 0.25rem;

            #multiSensorHiLModule2ProcessRightRow {
              flex: 1;
              display: flex;
              border-radius: 0.25rem;
              padding: 0 2.75rem;
              background-size: cover;
              background-repeat: no-repeat;
              flex-direction: column;
              border: 1px solid #282d45;
              justify-content: space-evenly;
              border-right: 0px solid #282d45;

              #multiSensorHiLModule2ProcessRightRowSense1,
              #multiSensorHiLModule2ProcessRightRowSense2,
              #multiSensorHiLModule2ProcessRightRowSense3,
              #multiSensorHiLModule2ProcessRightRowSense4 {
                display: flex;
                width: 30rem;
                align-items: center;
                aspect-ratio: 371/44;
                background-repeat: no-repeat;
                background-size: contain;
                justify-content: space-between;

                #multiSensorHiLModule2ProcessRightRowSenseBox {
                  display: flex;
                  align-items: center;
                  height: 2.75rem;
                  font-size: 1rem;
                  font-weight: 400;
                  @include display;
                  font-style: normal;
                  color: rgba(255, 255, 255, 0.85);
                  padding-left: 0.9375rem;

                  #multiSensorHiLModule2ProcessRightRowSenseBoxImg {
                    width: 1rem;
                    height: 1rem;
                    margin: 0.5rem 0.6rem 0.5rem;

                    img {
                      width: 1rem;
                      height: 1rem;
                      object-fit: cover;
                    }
                  }
                }

                #multiSensorHiLModule2ProcessRightRowSenseContent {
                  // flex: 1;
                  // display: flex;
                  // align-items: center;
                  width: 20rem !important;
                  margin-right: 1.5rem;
                  color: rgba(255, 255, 255, 0.85);
                  width: fit-content;
                  font-weight: 400;
                  font-size: 1rem;
                  font-style: normal;
                  box-sizing: border-box;
                  // padding-left: 3rem;
                  text-align: center;
                }
              }
            }

            #multiSensorHiLModule2ProcessRightCol {
              width: 4rem;
              font-size: 1rem;
              @include display;
              flex-direction: column;
              font-weight: 500;
              height: 18.75rem;
              text-align: center;
              aspect-ratio: 128/600;
              background-size: contain;
              background-repeat: no-repeat;
              color: rgba(255, 255, 255, 0.85);

              .vertical-text {
                text-orientation: upright;
              }
            }
          }
        }
      }
    }

    #multiSensorHiLModule3 {
      flex: 0.5;
      width: 100%;
      @include display;
      background-size: cover;
      padding: 4.1875rem 0 2.4375rem 0;
      /* @include whar(100%, 35.25rem, 1440/564); */
      /* @include whar(100%, auto, 1440/564); */
      /* background-color: red; */

      #multiSensorHiLModule3Box {
        // width: 58.375rem;
        /* height: 27.9375rem; */
        @include display;
        flex-direction: column;
        box-sizing: border-box;
        /* background-color: blue; */
        margin: auto;

        #multiSensorHiLModule3Title {
          margin: auto;
        }

        #multiSensorHiLModule3Title {
          @include fontStyle(
            600,
            3.125rem,
            2.25rem,
            3.125rem,
            0.06944rem,
            rgba(255, 255, 255, 0.85)
          );
          /* background-color: green; */
        }

        #multiSensorHiLModule3Video {
          width: 58.375rem;
          height: 21.4375rem;
          /* background-color: red; */

          img {
            width: 58.375rem;
            height: 21.4375rem;
            object-fit: cover;
          }
        }
      }
    }

    #multiSensorHiLFooter {
      width: 100%;
      height: 18rem;
    }
  }

  &.en {
    #multiSensorHiLModule2ProcessRightRowSenseBox {
      font-size: 0.65rem !important;
    }
    #multiSensorHiLModule2ProcessRightCol {
      .test-object {
        white-space: nowrap;
        transform: rotate(90deg);
      }
    }
    #meiDuShaModule1TextText1,
    #meiDuShaModule2 .tit .h2,
    #meiDuShaModuleNineContentOneBottom,
    #meiDuShaModuleNineContentTwoBottom,
    #meiDuShaModuleNineContentThreeBottom,
    #meiDuShaModuleNineContentFourBottom,
    #meiDuShaModuleNineContentFiveBottom {
      line-height: 1.5 !important;
      height: auto !important;
    }
    #meiDuShaModule3Bottom,
    #meiDuShaModuleNineContentTwo,
    #meiDuShaModuleNineContentThree,
    #meiDuShaModuleNineContentFour,
    #meiDuShaModuleNineContentFive {
      height: auto !important;
    }
    #meiDuShaModuleNineContentOneCenter,
    #meiDuShaModuleNineContentTwoCenter,
    #meiDuShaModuleNineContentThreeCenter,
    #meiDuShaModuleNineContentFourCenter,
    #meiDuShaModuleNineContentFiveCenter {
      height: 3rem;
      font-size: 0.955rem !important;
      line-height: 1.5 !important;
      font-weight: bold !important;
      // display: flex;
      // align-items: center;
      // justify-content: center;
    }
    #meiDuShaModuleNineContentOneBottom,
    #meiDuShaModuleNineContentTwoBottom,
    #meiDuShaModuleNineContentThreeBottom,
    #meiDuShaModuleNineContentFourBottom,
    #meiDuShaModuleNineContentFiveBottom {
      height: 7.5rem !important;
      // display: flex;
      // align-items: center;
      // justify-content: center;
    }
    // #meiDuShaModule2 .tit .h2 {
    //   text-align: justify !important;
    // }
  }
}
</style>
